export interface RollBlank {
	Id: number | null;
	Dwg: string;
	MillSizeId: number | null;
	MillSizeName: string | null;
	Description: string | null;
	Width: number | null;
	NewDiameter: number | null;
	ScrapDiameter: number | null;
	EstRCost: number | null;
	EstSCost: number | null;
	DTol: number | null;
	DTolm: number | null;
	RollApplicationId: number | null;
	RollApplicationName: string | null;
	RollMaterialId: number | null;
	RollMaterialName: string | null;
	HardnessMinimum: number | null;
	HardnessMaximum: number | null;
	DwgName: string | null;
	DwgTimestamp: string | null;
	PitProgramName: string | null;
	Active: boolean;
}

export const ROLL_BLANK_INITIAL_VALUES: RollBlank = {
	Id: null,
	Dwg: "",
	MillSizeId: null,
	MillSizeName: null,
	Description: null,
	Width: null,
	NewDiameter: null,
	ScrapDiameter: null,
	EstRCost: null,
	EstSCost: null,
	DTol: null,
	DTolm: null,
	RollApplicationId: null,
	RollApplicationName: null,
	RollMaterialId: null,
	RollMaterialName: null,
	HardnessMinimum: null,
	HardnessMaximum: null,
	DwgName: null,
	DwgTimestamp: null,
	PitProgramName: null,
	Active: true,
};

export interface MillSize {
	Id: number;
	Name: string;
}

export interface RollApplication {
	Id: number;
	Name: string;
}

export interface RollMaterial {
	Id: number;
	Name: string;
}

export interface RollBlankAttachment {
	RollBlankAttachmentId: number;
	RollBlankId: number;
	UploadFileId: number;
	AttachmentName: string;
	AttachmentURL: string;
	CreationTime: Date;
	CreatedBy: string;
	URL: string;
}
